// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2wUx1","title":"Header_title__3EUdp","left":"Header_left__nfQ4t","clinicName":"Header_clinicName__bqeBr"};